"use client";
import React, { useEffect, useState } from "react";
import { Flex, Text, Title } from "@/app/[lang]/components/ui/AntdLite";
import { useRouter, useSearchParams } from "next/navigation";
import DOMPurify from "@/app/[lang]/utils/dompurify";

import styles from "./SearchFAQs.module.scss";
import Button from "../ui/Button";
import search from "../../utils/search";
import Pagination from "../Pagination";

interface FAQProps {
  id: number;
  title: string;
  description: string;
}



interface SearchFAQsProps {
  title: string;
  buttonText: string;
  onClick?: () => void;
}

const PAGE_SIZE = 9;

export const SearchFAQs = ({ title, buttonText, onClick }: SearchFAQsProps) => {
  const searchParams = useSearchParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [parsedResults, setParsedResults] = useState<any>({});
  const router = useRouter();

  useEffect(() => {
    const query = searchParams.get("query");
    if (query) {
      search(query, "faqs", currentPage, PAGE_SIZE)
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          setParsedResults({
            total: data.faqs?.meta?.pagination?.total || 0,
            ...data,
          });
        });
    }
  }, [searchParams, currentPage]);

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const redirect = (id: number) => {
    router.push(`/intrebari-frecvente?id=${id}`);
  };

  return parsedResults.faqs && parsedResults.faqs?.data?.length > 0 ? (
    <section className={styles.questionsWrapper}>
      <div className="container">
        <Title level={2} className={styles.title}>
          <span
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }}
          />
        </Title>

        <Flex className={styles.questions} gap="24px" wrap="wrap">
          {parsedResults.faqs?.data?.map((faq: FAQProps) => (
            <Text key={faq.id} onClick={() => redirect(faq.id)}>
              {faq.title}
            </Text>
          ))}
        </Flex>

        {!onClick && parsedResults.total > PAGE_SIZE && (
          <Pagination
            defaultCurrent={currentPage}
            total={parsedResults.total}
            pageSize={PAGE_SIZE}
            onChange={handlePageChange}
          />
        )}

        {onClick && parsedResults.total > PAGE_SIZE && (
          <Flex justify="flex-end">
            <Button
              attributes={{
                type: "outline",
                backgroundColor: "black",
                textColor: "black",
                hoverColor: "light-blue",
              }}
              onClick={onClick}
            >
              {buttonText}
            </Button>
          </Flex>
        )}
      </div>
    </section>
  ) : (
    <p>...</p>
  );
};
